import { render, staticRenderFns } from "./cModalAddEmailContent.vue?vue&type=template&id=2cb5061e"
import script from "./cModalAddEmailContent.vue?vue&type=script&lang=js"
export * from "./cModalAddEmailContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports